module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-1",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("RACHEL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-1-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("May 1999")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break scene-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("When Rachel tried to recall that day, a fog descended. It was as if someone had interfered with her memory, superimposing their own view and erasing hers. Sometimes fragments came back to her: the heat and the clamour; screeching magpies; a pneumatic drill ripping up the main road into the village making it impossible to concentrate on her revision.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She had a hazy memory of tramping across the lawn, away from the house, towards a secluded copse near the boundary wall. The dappled shade of the trees beckoned her in. She sank down on a wooden bench and began memorising the King Lear quotes she’d scribbled on index cards as revision for her A level exam.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("What happened next? Did someone call out to her?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("More noise. She froze. The voice was barking orders and instructions. Why couldn’t they leave her alone? What did they want now?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("With an effort, she heaved herself to her feet, preparing to leave the sanctuary of the wood and return to the house, but then stopped. Surely, whatever it was could wait? She’d do it later.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The last thing she remembered was snatching up her earphones and jamming them on; the foam covering was peeling off and black plastic scratched her ears, but she turned the music on her Walkman up louder. The jerky beat of "), _c('i', [_vm._v("My Name Is ")]), _vm._v("drowned the clamour and Eminem’s lyrics took on a trancelike effect. Sunshine slanted through the leaves, stinging her eyes. She closed them and leaned her head back against the trunk of a silver birch. Just for a few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A shout woke her, then a scream – awful, curdling – loud enough to penetrate the flimsy earphones. She pulled them off, the wires curled like a tangled necklace. Footsteps pounded on the stone steps that led from the upper terrace of The Old Rectory to the gravel courtyard below. The scream morphed into a wail, followed by more shouting and her mother’s voice, shrill and desperate, shrieking, “George, Georgie. Wake up, baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rachel shivered. She crept to the fringe of the copse and peered across the lawn towards the house. Her view of the lower courtyard was blocked by figures bending over something. Above their heads she could see the top tiers of the ornamental fountain: the statue of a nymph, balancing an urn on her head and holding a fish with herringbone-etched scales, under her other arm. The fish’s lolling head spouted water into the deep pond beneath.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The air stilled; the birds fell silent. Her mother was cradling a bundle in her arms; her father pulled off his shirt and spread it on the ground. As they both knelt on the grass, Rachel had a clear view of her parents bending over the inert figure of her baby brother, George…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Heart hammering, Rachel shrank back into the shelter of the trees. She shivered, then she ran, her bare feet carrying her rapidly, not towards the scene. But away.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1da35a28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-001.vue
// module id = 75
// module chunks = 0